import imgPolycamera from "../../assets/images/test-drive-polycamera.webp";
import imgSecond1 from "../../assets/images/test-drive-second1.webp";
import imgSecond2 from "../../assets/images/test-drive-second2.webp";
import imgRecorder from "../../assets/images/test-drive-recorder.webp";
import imgTopView from "../../assets/images/test-drive-top-view.webp";
import imgSideView from "../../assets/images/test-drive-side-view.webp";
import './TestDrive.scss';
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

const TestDrivePage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="test-drive">
            <div className="test-drive-start">
                <div className="test-drive-container">
                    <h1>{t("test_drive_section.title")}</h1>
                    <div className="test-drive-about">
                        <div className="test-drive-about-text">
                            <h2>{t("test_drive_section.about_block.heading1")}
                            </h2>
                            <h2>{t("test_drive_section.about_block.heading2")}
                            </h2>
                            <a href="tel:+79252063075" className="btn__test" target="_blank">{t("test_drive_section.about_block.button_text")}</a>
                        </div>
                        <img src={imgPolycamera} alt="polycamera" className="test-drive-about-img" />
                    </div>
                    <div className="test-drive-title-container">
                        <h2 className="title">{t("test_drive_section.test_drive_title.main")}</h2>
                        <h2 className="subtitle">{t("test_drive_section.test_drive_title.sub")}</h2>
                        <div className="text">{t("test_drive_section.test_drive_title.description")}</div>
                    </div>
                </div>
            </div>
            <div className="test-drive-second">
                <div className="test-drive-container">
                    <div className="solution">
                        <div className="solution__text ">
                            <p className="solution__p">{t("test_drive_section.solution_blocks.block1.text")}</p>
                        </div>
                        <img src={imgSecond1} alt="Stadiums" className="solution__img" />
                    </div>
                    <div className="solution">
                        <div className="solution__text ">
                            <p className="solution__p">{t("test_drive_section.solution_blocks.block2.text")}
                            </p>
                        </div>
                        <img src={imgSecond2} alt="safe city" className="solution__img" />
                    </div>
                </div>
            </div>
            <div className="test-drive-products">
                <div className="test-drive-products-title">
                    <h2> <Trans i18nKey={'test_drive_section.products_section.title'} components={{ 1: <span /> }} />
                       </h2>
                </div>
                <div className="test-drive-container">
                    <div className="test-drive-product">
                        <div className="test-drive-product-img">
                            <img src={imgRecorder} alt="" />
                            <Link to='/products' className="test-drive-product-link">{t("test_drive_section.products_section.products.product1.link_text")}</Link>
                        </div>
                        <div className="test-drive-product-text">
                            <h3>{t("test_drive_section.products_section.products.product1.name")}</h3>
                            <p>{t("test_drive_section.products_section.products.product1.description1")}
                            </p>
                            <p>{t("test_drive_section.products_section.products.product1.description2")}
                            </p>
                        </div>

                    </div>
                    <div className="test-drive-product">
                        <div className="test-drive-product-img">
                            <img src={imgPolycamera} alt="" />
                            <Link to='/products' className="test-drive-product-link">{t("test_drive_section.products_section.products.product2.link_text")}</Link>
                        </div>
                        <div className="test-drive-product-text">
                            <h3>{t("test_drive_section.products_section.products.product2.name")}</h3>
                            <p>{t("test_drive_section.products_section.products.product2.description1")}</p>
                            <p>{t("test_drive_section.products_section.products.product2.description2")}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="test-drive-models">
                <div className="test-drive-container">
                    <h2>{t("test_drive_section.models_section.heading1")}
                    </h2>
                    <div className="test-drive-models-imgs">
                        <img src={imgTopView} alt="" />
                        <img src={imgSideView} alt="" />
                    </div>
                    <h2>{t("test_drive_section.models_section.heading2")}
                    </h2>
                </div>
            </div>
        </section>
    )
}

export default TestDrivePage;